import { shallowRef } from 'vue'

// Слот для последней пойманной 5xx-ошибки от API. Заполняется в DEV-режиме
// (см. middleware в @/api/client). Прод-сборка тоже импортирует модуль, но
// middleware туда ничего не пишет — overlay остаётся пустым и не рендерится.
export interface DevErrorSnapshot {
  status: number
  url: string
  method: string
  body: string
  contentType: string
  receivedAt: Date
}

const error = shallowRef<DevErrorSnapshot | null>(null)

export function useDevError() {
  return {
    error,
    set: (value: DevErrorSnapshot) => { error.value = value },
    clear: () => { error.value = null }
  }
}
